var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnPaid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_250",
    "data-name": "Group 250",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 34,
    height: 34,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(-3242.017 -1750.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229",
    transform: "translate(3245.766 1756.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M10.691,6.5c-4.063,0-8.383-1.139-8.383-3.25S6.628,0,10.691,0s8.385,1.14,8.385,3.251S14.755,6.5,10.691,6.5m0-5.5C6.117,1,3.308,2.312,3.308,3.251S6.117,5.5,10.691,5.5s7.385-1.311,7.385-2.25S15.266,1,10.691,1",
    fill: "#50abf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M10.691,6.5c-4.063,0-8.383-1.139-8.383-3.25a.5.5,0,0,1,1,0c0,.939,2.809,2.25,7.383,2.25s7.385-1.311,7.385-2.25a.5.5,0,0,1,1,0c0,2.111-4.321,3.25-8.385,3.25",
    fill: "#50abf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M10.691,9.606c-4.063,0-8.383-1.139-8.383-3.25a.5.5,0,0,1,1,0c0,.939,2.809,2.25,7.383,2.25.458,0,.908-.014,1.345-.04a.5.5,0,0,1,.06,1c-.455.028-.926.042-1.4.042",
    fill: "#50abf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M2.809,6.856a.5.5,0,0,1-.5-.5V3.288a.5.5,0,0,1,1,0V6.356a.5.5,0,0,1-.5.5",
    fill: "#50abf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M18.575,6.536a.5.5,0,0,1-.5-.5V3.288a.5.5,0,0,1,1,0V6.036a.5.5,0,0,1-.5.5",
    fill: "#50abf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M10.114,15.571H10.1c-3.707-.1-6.66-1.023-7.522-2.367a.5.5,0,1,1,.842-.541c.563.878,3.047,1.815,6.706,1.908a.5.5,0,0,1-.013,1",
    fill: "#50abf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M11.071,18.681c-4.308,0-8.763-1.214-8.763-3.246a.5.5,0,0,1,1,0c0,.894,3.1,2.246,7.763,2.246a.5.5,0,1,1,0,1",
    fill: "#50abf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M8.383,10.721C4.319,10.721,0,9.582,0,7.471c0-.677.452-1.644,2.606-2.4a.5.5,0,0,1,.332.943C1.742,6.432,1,6.992,1,7.471c0,.939,2.809,2.25,7.383,2.25a21.1,21.1,0,0,0,2.631-.16.5.5,0,0,1,.125.992,22.138,22.138,0,0,1-2.756.168",
    fill: "#50abf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M8.383,13.826C4.319,13.826,0,12.687,0,10.576a.5.5,0,0,1,1,0c0,.939,2.809,2.25,7.383,2.25.6,0,1.2-.024,1.783-.071a.507.507,0,0,1,.539.457.5.5,0,0,1-.457.539c-.607.05-1.235.075-1.865.075",
    fill: "#50abf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M.5,11.076a.5.5,0,0,1-.5-.5V7.508a.5.5,0,0,1,1,0v3.068a.5.5,0,0,1-.5.5",
    fill: "#50abf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M2.809,16.213a.5.5,0,0,1-.5-.5V13.022a.5.5,0,0,1,1,0v2.691a.5.5,0,0,1-.5.5",
    fill: "#50abf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M18.118,22.5A8.383,8.383,0,1,1,26.5,14.121,8.393,8.393,0,0,1,18.118,22.5m0-15.767A7.383,7.383,0,1,0,25.5,14.121a7.392,7.392,0,0,0-7.384-7.383",
    fill: "#50abf8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 1.11,
    height: 9.995,
    rx: 0.555,
    transform: "translate(3260 1767.785) rotate(-45)",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 1.111,
    height: 9.995,
    rx: 0.555,
    transform: "translate(3267.068 1767) rotate(45)",
    fill: "#0d292d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnPaid);
export default __webpack_public_path__ + "static/media/unPaid.f3febabe2a6980437814232c93cb3e56.svg";
export { ForwardRef as ReactComponent };